import { Avatar, Box, Flex, Group, Menu, Modal, Text, UnstyledButton, useMantineTheme } from "@mantine/core";
import { IconChevronDown, IconKey, IconLock, IconLogout, IconPhoto } from "@tabler/icons-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthApi } from "../../apis";
import { ReactComponent as EraLogo } from "../../assets/logo.svg";
import noimage from "../../assets/no-image.png";
import { authChange, authMe } from "../../store/Auth";
import { Message } from "../../utils/message";
import { Changepassword } from "../settings/change-password";
import { ChangePin } from "../settings/change-pin";
import classes from "./header.module.css";

export const Header = () => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [action, setAction] = React.useState<any>([]);

  const { user } = useSelector((state: any) => state.auth);

  const LogOut = async () => {
    try {
      await AuthApi.logout();

      const removeToken = { accessToken: null };
      const removeUser = {};
      dispatch(authChange(removeToken as any));
      dispatch(authMe(removeUser as any));
      navigate("/auth/login");
    } catch (error: any) {
      Message.error(error?.message);
    }
  };

  return (
    <Box component="header" className={classes.header}>
      <Box className={classes.row}>
        <Flex align="center" gap={8}>
          <EraLogo className={classes.logo} />
          <Box component="span">
            <Box className={classes.logoText}>DeHUB</Box>
            <Box className={classes.logoDesc}>платформ</Box>
          </Box>
        </Flex>
        {user && user?.id ? (
          <Menu position="bottom-end">
            <Menu.Target>
              <UnstyledButton className={classes.user}>
                <Group>
                  <Avatar src={user?.avatar !== null ? user?.avatar : noimage} radius="xl">
                    <IconPhoto />
                  </Avatar>
                  <Box style={{ flex: 1 }}>
                    <Text c="white" size="sm" fw={500}>
                      {user?.lastName ? (
                        <>
                          {user?.lastName}.{user?.firstName}
                        </>
                      ) : (
                        "-"
                      )}
                    </Text>
                    <Text c="white" size="xs">
                      {user?.email}
                    </Text>
                  </Box>
                  <IconChevronDown size={14} stroke={1.5} fill="white" />
                </Group>
              </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => setAction([true, "pin"])} leftSection={<IconKey size={20} color={theme.colors.yellow[6]} stroke={1.5} />}>
                Пин код
              </Menu.Item>
              <Menu.Item onClick={() => setAction([true, "password"])} leftSection={<IconLock size={20} color={theme.colors.blue[6]} stroke={1.5} />}>
                Нууц үг
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item color="red" onClick={() => LogOut()} leftSection={<IconLogout size={20} stroke={1.5} />}>
                Системээс гарах
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        ) : null}

        <Modal opened={action[0]} onClose={() => setAction([])} centered withCloseButton={false}>
          <Box>
            {action[1] === "pin" && <ChangePin onClose={() => setAction([])} />}
            {action[1] === "password" && <Changepassword onClose={() => setAction([])} />}
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default Header;
